import { render, staticRenderFns } from "./AppNetherlands.vue?vue&type=template&id=665b1997&"
import script from "./AppNetherlands.vue?vue&type=script&lang=js&"
export * from "./AppNetherlands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports